<template>
  <div class="table_performance_warp">
    <el-table :cell-style="getRowClass" :header-cell-style="getRowClass" max-height="500" :data="newTabData"
      style="width: 100%">
      <el-table-column width="100px" align="center" label="ID">
        <template slot-scope="props">
          <div class="link" @click="linkToPage(props.row)">{{  props.row.tid || props.row.pid }}</div>
        </template>
      </el-table-column>
      <el-table-column label="名称" prop="title" />
      <el-table-column label="计划完成时间" :formatter="formatPet" prop="pet" />
      <el-table-column label="实际完成时间" :formatter="formatAet" prop="aet" />
    </el-table>
  </div>
</template>
<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    newTabData(newVal,oldVal){
      return this.tableData;
    }
  },
  mounted() {
    console.log(this.tableData);
  },
  methods: {
    getRowClass({ row, column, rowIndex, columnIndex }) {
      return "background:#f1fbec";
    },
    formatPet(row) {
      return this.$moment(row.pet*1).format('YYYY-MM-DD HH:mm:ss')
    },
    formatAet(row) {
      return this.$moment(row.aet*1).format('YYYY-MM-DD HH:mm:ss')
    },
    linkToPage(data){
      let url = `${window.location.origin}/devops/space/producer?route=devOpsProducerSpace?pid=${data.pid}&pop=1`
      if(data.tid){
        url += `&tid=${data.tid}`
      }
      window.open(url)
    }
  },
};
</script>
<style lang="scss" scoped>
.table_performance_warp {
  background: #f1fbec;

  .link {
    color: #409EFF;
    cursor: pointer;
  }
}
</style>

<style  lang="scss">
.table_performance_warp {

  .el-table__body-wrapper {
    scrollbar-width: thin;
    scrollbar-color: skyblue #eee;
  }

  .el-table__body-wrapper::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 10px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }

  .el-table__body-wrapper::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    background-color: skyblue;
    background-image: -webkit-linear-gradient(45deg,
        rgba(255, 255, 255, 0.2) 25%,
        transparent 25%,
        transparent 50%,
        rgba(255, 255, 255, 0.2) 50%,
        rgba(255, 255, 255, 0.2) 75%,
        transparent 75%,
        transparent);
  }

  .el-table__body-wrapper::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #ededed;
    border-radius: 10px;
  }
}
</style>